import { Link } from 'react-router-dom'
import config from '../../config'
import { useTranslation } from '@/hooks/useTranslation'
import {
	LegalH3,
	LegalList,
	LegalP,
	LegalPageLayout,
	LegalSection,
	useLegalList,
	useLegalUpdatedDate,
} from '@/components/legal/LegalPageLayout'

const CookiePolicy = () => {
	const { t } = useTranslation()
	const date = useLegalUpdatedDate()
	const necessaryItems = useLegalList('cookiePolicy.necessaryItems')
	const analyticsItems = useLegalList('cookiePolicy.analyticsItems')
	const affiliateItems = useLegalList('cookiePolicy.affiliateItems')

	return (
		<LegalPageLayout
			title={t('cookiePolicy.title')}
			lastUpdated={t('legal.lastUpdated', { date })}
		>
			<LegalSection title={t('cookiePolicy.section1Title')}>
				<LegalP>{t('cookiePolicy.section1Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('cookiePolicy.section2Title')}>
				<LegalH3>{t('cookiePolicy.necessaryTitle')}</LegalH3>
				<LegalP>{t('cookiePolicy.necessaryIntro')}</LegalP>
				<LegalList items={necessaryItems} />

				<LegalH3>{t('cookiePolicy.analyticsTitle')}</LegalH3>
				<LegalP>{t('cookiePolicy.analyticsIntro')}</LegalP>
				<LegalList items={analyticsItems} />

				<LegalH3>{t('cookiePolicy.affiliateTitle')}</LegalH3>
				<LegalP>{t('cookiePolicy.affiliateIntro')}</LegalP>
				<LegalList items={affiliateItems} />
			</LegalSection>

			<LegalSection title={t('cookiePolicy.section3Title')}>
				<LegalP>{t('cookiePolicy.section3Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('cookiePolicy.section4Title')}>
				<LegalP>{t('cookiePolicy.section4Content')}</LegalP>
				<LegalP>
					{t('cookiePolicy.section4Privacy')}{' '}
					<Link
						to="/privacy"
						className="text-primary hover:text-primary/90 font-medium"
					>
						{t('terms.privacyPolicy')}
					</Link>
					.
				</LegalP>
			</LegalSection>

			<LegalSection title={t('cookiePolicy.section5Title')}>
				<LegalP>
					{t('cookiePolicy.contactContent', {
						supportEmail: config.supportEmail,
					})}
				</LegalP>
			</LegalSection>
		</LegalPageLayout>
	)
}

export default CookiePolicy
